import { render } from "./PatientsListTab.vue?vue&type=template&id=16ce93be"
import script from "./PatientsListTab.vue?vue&type=script&lang=js"
export * from "./PatientsListTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__